import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../State';
import { CustomerActionTypes } from '../State/actions/customers.actions';
import { getCustomerLatestUpdatedAt, getCustomersFetched } from '../State/selectors/customers.selectors';
import { BaseEntityReloadResolver2 } from './resolver.helper';
import { GetTimestampFromTime } from '@dave/types';

@Injectable({
    providedIn: 'root',
})
export class CustomerResolver extends BaseEntityReloadResolver2 {
    constructor(store: Store<State>) {
        super(getCustomersFetched, getCustomerLatestUpdatedAt, CustomerActionTypes.Load, store, (d) => GetTimestampFromTime(d).toString());
    }
}
